import { WidgetsReportsMain } from '@/widgets/reports';

export const PagesReportsVideoMain = () => <WidgetsReportsMain type="VIDEO" />;
